import { render, staticRenderFns } from "./history.vue?vue&type=template&id=59ba61a7&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ba61a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/s01-aiart-release-cn/s01_haiyiai_release-cn_aiart-web-openapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59ba61a7')) {
      api.createRecord('59ba61a7', component.options)
    } else {
      api.reload('59ba61a7', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=59ba61a7&scoped=true&", function () {
      api.rerender('59ba61a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/purchase/history.vue"
export default component.exports